<template>
	<div class="custom_image_upload">
		<loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
		<CommonHead></CommonHead>
		<div class="container container-desktop">
			<b-breadcrumb :items="breadcrumb"></b-breadcrumb>
			<div class="my-5">
				<!-- <img src="https://via.placeholder.com/350x100" width="100%" alt="placeholder image"> -->
				<div class="custom_print_head_div">
					<img src="/shop/images/custom_print_head_img.png" width="100%" class="custom_print_head_img" alt="custom print head image">
					<div class="custom_print_head_content">
						<img src="/shop/images/custom_print_head_logo.svg" class="custom_print_head_svg" alt="custom print head logo">
						<h2 class="heading">
							<b>To-The-Trade</b> Custom Printed Fabrics
						</h2>
					</div>
				</div>
			</div>
			<h1 class="py-4 text-center font-weight-normal">Upload Your Print Ready File</h1>
			<div class="row d-flex my-5 mb-7 threeboxarea">
				<div class="col-lg-12 col-xl-4">
					<div class="card">
						<div class="card-body">
							<h2 class="text-left">1. Select Your File</h2>
							<ul class="select_file_ul">
								<li>Acceptable formats: <b>JPG, PNG</b></li>
								<li>Files must be less then <b>20MB</b></li>
								<li>File must have resolution of at least <b>150 PPI</b></li>
								<li>Pattern must repeat horizontally and vertically</li>
							</ul>
							<div class="d-flex align-items-center justify-content-start">
								<input type="file" name="image" id="image" ref="image_input_elem" @change="imageSelected()" style="display: none;" accept="image/jpg, image/jpeg, image/png">
								<button class="btn btn-dark choose_btn px-4" @click="imageSelect()">Choose File</button>
								<span class="ml-4">
									{{ form.image_name == '' ? 'No file choosen' : form.image_name }}
								</span>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-12 col-xl-4">
					<div class="card">
						<div class="card-body">
							<h2 class="text-left">2. Confirm Copyright</h2>
							<div class="d-flex">
								<div class="mr-3">
									<md-checkbox v-model="form.confirm_copyright"></md-checkbox>
								</div>
								<div>
									I own the rights or have permission to use this content, and agree to the RM COCO <a class="text-dark" href="/terms-of-services/"><b>Terms of Service</b></a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-12 col-xl-4">
					<div class="card">
						<div class="card-body">
							<h2 class="text-left">3. Upload Your File</h2>
							<button class="btn upload_btn btn-dark" :disabled="!upload_btn" @click="imageUploadHandlder()">Upload</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="container container-desktop d-flex justify-content-center align-items-center mb-7">
			<h3>Have an idea but need RM COCO's help putting your design file together?<br>Email your idea to <a href="mailto:colorworks@rmcoco.com">colorworks@rmcoco.com</a> and let our design team help!</h3>
		</div>
		<div class="container container-mobile d-flex justify-content-center align-items-center my-5">
			<h4>OOPS! This page is not available for mobile devices. Please access via desktop or laptop.</h4>
		</div>
		<CommonFoot></CommonFoot>
	</div>
</template>

<script>
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapGetters } from 'vuex';
export default {
	components: {
		CommonHead,
		CommonFoot,
		Loading,
	},
	 metaInfo: {
    title: 'RM COCO | Custom Print Image Upload',
    meta: [{
        name: 'description',
        content: 'Custom print image upload.'
    }],
  },
	data() {
		return {
			isLoading: false,
			upload_btn: false,
			form: {
				confirm_copyright: false,
				image: '',
				image_name: ''
			},
			error: '',
			valid_ext: ['jpeg', 'jpg', 'png'],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Custom Prints',
					href: '/'
				},
				{
					text: 'Upload Image',
					active: true
				}
			]
		}
	},
	computed: {
		...mapGetters(["user"]),
	},
	mounted() {
		if (!this.user) {
			this.$router.push({ name: 'login'});
		}
	},
	methods: {
		imageUploadHandlder() {
			let input = this.$refs.image_input_elem;
			let file = input.files;
			let formData = new FormData();
			formData.append('image', file[0]);
			formData.append('image_name', this.form.image_name);
			this.isLoading = true;
			this.$store.dispatch("loadCustomImageUpload", formData).then(res => {
				this.$refs.image_input_elem.value = '';
				this.form.image = '';
				this.form.image_name = '';
				this.isLoading = false;
				this.$notify({
					text: "Image uploaded successfully.",
					type: "success"
				});
				this.$router.push({ name: 'custom-print-image-upload-update', params: { id: res.data.id } });
			});
		},
		imageSelect() {
			this.$refs.image_input_elem.click();
		},
		imageSelected () {
			this.isLoading = true;
			let input = this.$refs.image_input_elem;
			let file = input.files;
			if (file && file[0]) {
				this.error = '';
				this.form.image = '';
				this.form.image_name = '';
				let reader = new FileReader;
				let file_ext = file[0].name.split('.')[1];
				if (this.valid_ext.indexOf(file_ext) === -1) {
					this.$notify({
						text: "Please select valid image file.",
						type: "error"
					});
					this.isLoading = false;
					return false;
				}
				let image_size_in_mb = this.bytesToMB(file[0].size);
				if (image_size_in_mb > 20) {
					this.$notify({
						text: "Selected file size must be less then 20MB.",
						type: "error"
					});
					this.isLoading = false;
					return false;
				}
				reader.readAsDataURL(file[0]);
				this.form.image_name = file[0].name;
				reader.onload = e => {
					this.form.image = e.target.result;
					var i = new Image(); 
					i.src = this.form.image; 
					i.onload = () => {
						if (i.width <= 8100 && i.height <= 5400) {
							this.isLoading = false;
						} else {
							this.$refs.image_input_elem.value = '';
							this.form.image = '';
							this.form.image_name = '';
							this.$notify({
								text: 'Selected file size dimensions must be smaller than 54” x 36”',
								type: "error"
							});
							this.isLoading = false;
							return false;
						}
					};
				}
			}
		},
		bytesToMB(bytes) {
			return (bytes / 1048576).toFixed(2);
		}
	},
	watch: {
		form: {
			handler: function() {
				if (this.form.confirm_copyright === true && this.form.image != '') {
					this.upload_btn = true;
				} else {
					this.upload_btn = false;
				}
			},
			deep: true
		},
	}
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display&display=swap');
</style>
<style scoped>
.mb-7{
	margin-bottom: 7rem !important;
}
.custom_image_upload .card{
	background-color: #ECECEC;
	height: 100%;
}
.custom_image_upload .card .card-body{
	padding: 30px;
}
.custom_image_upload .card h2 {
	font-size: 20px;
	margin-bottom: 25px;
}
.custom_image_upload .upload_btn {
	width: 130px;
}
.custom_image_upload, ul.select_file_ul li {
	list-style: auto;
	list-style-type: disc;
	list-style-position: inside;
	margin-bottom: 2rem;
}
.choose_btn{
	width: 170px;
}
.custom_print_head_div {
	position: relative;
}
.custom_print_head_img {
	filter: brightness(50%);
	opacity: 0.9;
}
.custom_print_head_content {
	position: absolute;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
	text-align: center;
}
.custom_print_head_content .custom_print_head_svg {
	text-align: center;
	margin-bottom: 20px;
	width: 25%;
}
.custom_print_head_content h2.heading {
	font-size: 40px;
	color: white !important;
	font-family: 'Playfair Display', serif;
}

.container-mobile{
	display: none !important;
}

.custom_image_upload .row .col-xl-4 {
	-webkit-box-flex: 0;
	flex: 0 0 33.3333333333%;
	max-width: 33.3333333333%;
}
.custom_image_upload .threeboxarea{
	margin: 0 -30px;
}
.custom_image_upload .threeboxarea .col-xl-4{
	padding: 0 30px;
}
@media only screen and (max-width: 767px) {
	.container-desktop{
		display: none !important;
	}

	.container-mobile{
		display: flex !important;
	}
}
	@media only screen and (max-width: 1024px) {
		.custom_print_head_div .custom_print_head_content .custom_print_head_svg {
			margin-bottom: 5px;
		}
		.custom_print_head_div .custom_print_head_content h2.heading {
			font-size: 25px;
		}
		.custom_image_upload .card h2 {
			font-size: 18px;
			margin-bottom: 14px;
		}
		.custom_image_upload ul.select_file_ul li.mb-3 {
			margin-bottom: 5px !important;
		}
		.custom_image_upload .row .col-lg-12 {
			-webkit-box-flex: 0;
			flex: 0 0 100%;
			max-width: 100%;
			margin-bottom: 16px;
		}
	}
</style>